export default "__VITE_ASSET__49ffe96e__"